import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import AddSomethingModal from 'donor-elf-web/services/add-something-modal';

export default class JournalController extends Controller {
  @service declare addSomethingModal: AddSomethingModal;

  @action
  templateDidInsert() {
    this.addSomethingModal.showGotoDetailPage = false;
    this.addSomethingModal.showAddContactToJournalCheckbox = true;
  }

  @action
  templateWillDestroy() {
    this.addSomethingModal.showGotoDetailPage = true;
    this.addSomethingModal.showAddContactToJournalCheckbox = false;
  }
}
